@if (open) {
  <div
    class="ofertas-modal"
    [class.ofertas-modal--sheet]="open === 'comparar'"
    [class.ofertas-modal--garantias]="open === 'garantias'"
    [class.ofertas-modal--tomar]="open === 'tomar1' || open === 'tomar2'"
    [class.ofertas-modal--salir]="open === 'salir'"
    [class.ofertas-modal--rechazar]="open === 'rechazar'"
    role="dialog"
    aria-modal="true"
    (click)="onBackdrop($event)"
  >
    <div class="ofertas-modal__panel" (click)="$event.stopPropagation()">
      <header class="ofertas-modal__header">
        <span class="ofertas-modal__header-spacer" aria-hidden="true"></span>
        <h2 class="ofertas-modal__title">
          @switch (open) {
            @case ('salir') {
              {{ copy.modalSalirTitulo }}
            }
            @case ('garantias') {
              {{ copy.modalGarantiasTitulo }}
            }
            @case ('tomar1') {
              {{ copy.modalTomarTitulo }}
            }
            @case ('tomar2') {
              {{ copy.modalTomar2Titulo }}
            }
            @case ('rechazar') {
              {{ copy.modalRechazarTitulo }}
            }
            @case ('comparar') {
              {{ copy.compararTitulo }}
            }
          }
        </h2>
        <button type="button" class="ofertas-modal__close" aria-label="Cerrar" (click)="onClose()">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>

      <div class="ofertas-modal__body">
        @if (open === 'salir') {
          <p class="ofertas-modal__text">
            {{ copy.modalSalirAntes(dias) }}<strong>{{ copy.modalSalirEnfasis }}</strong
            >{{ copy.modalSalirDespues }}
          </p>
          <div class="ofertas-modal__actions">
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--soft"
              id="btn-ofertas-salir"
              (click)="onSalir()"
            >
              {{ copy.salir }}
            </button>
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--primary"
              id="btn-ofertas-revisar"
              (click)="onRevisar()"
            >
              {{ copy.revisarOfertasCta }}
            </button>
          </div>
        }

        @if (open === 'garantias' && oferta) {
          <p class="ofertas-modal__text">{{ copy.modalGarantiasIntro }}</p>
          <div class="ofertas-modal__garantias-box">
            <table class="ofertas-modal__garantias-table">
              <thead>
                <tr>
                  <th>{{ copy.concepto }}</th>
                  <th>{{ copy.tipoPago }}</th>
                  <th>{{ copy.valor }}</th>
                </tr>
              </thead>
              <tbody>
                @for (cargo of oferta.neoCargoComisiones; track cargo.descripcion) {
                  <tr>
                    <td>{{ cargo.descripcion }}</td>
                    <td>{{ cargo.tipoCargo }}</td>
                    <td>{{ dinero(cargo.monto) }}</td>
                  </tr>
                }
                <tr class="ofertas-modal__garantias-total">
                  <td>{{ copy.totalGarantias }}</td>
                  <td></td>
                  <td>{{ dinero(totalGarantias(oferta)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="ofertas-modal__text">
            {{ copy.modalGarantiasDescuento(totalGarantias(oferta), oferta.monto) }}
          </p>
          <button
            type="button"
            class="ofertas-modal__btn ofertas-modal__btn--soft"
            id="btn-ofertas-garantias-aceptar"
            (click)="trackModalCta(copy.aceptar, 'btn-ofertas-garantias-aceptar'); onClose()"
          >
            {{ copy.aceptar }}
          </button>
        }

        @if (open === 'tomar1' && oferta) {
          <p class="ofertas-modal__lead">
            {{ copy.modalTomarLeadAntes }}<strong>{{ oferta.nombreIntermediario }}</strong
            >{{ copy.modalTomarLeadDespues }}
          </p>
          <div class="ofertas-modal__tomar-box">
            @for (fila of filasTomar(oferta); track fila.label) {
              <div class="ofertas-modal__tomar-row">
                <span class="ofertas-modal__tomar-label">
                  <span class="ofertas-modal__tomar-icon" aria-hidden="true">{{ fila.icon }}</span>
                  {{ fila.label }}
                </span>
                <span class="ofertas-modal__tomar-value">{{ fila.value }}</span>
              </div>
            }
          </div>
          <label class="ofertas-modal__check">
            <input type="checkbox" [checked]="acepta078" (change)="acepta078 = !acepta078" />
            <span>{{ par078 || copy.par078Fallback }}</span>
          </label>
        }

        @if (open === 'tomar2' && oferta) {
          <p class="ofertas-modal__text">{{ par079 || copy.par079Fallback }}</p>
          @if (requiereDocsSegmento) {
            <div class="ofertas-modal__docs">
              <p class="ofertas-modal__docs-auth">
                {{ copy.docsSegmentoAuth }}
                <button
                  type="button"
                  class="ofertas-modal__docs-auth-link"
                  (click)="abrirAuthBancoldex()"
                >
                  {{ copy.docsSegmentoAuthLink }}
                </button>
              </p>
              @if (docsSegmentoCatalogo.length > 0) {
                <h3 class="ofertas-modal__docs-title">{{ copy.docsSegmentoTitulo }}</h3>
                <p class="ofertas-modal__hint">{{ copy.docsSegmentoHint }}</p>
                <ul class="ofertas-modal__docs-list">
                @for (doc of docsSegmentoCatalogo; track doc.id; let i = $index) {
                  <li class="ofertas-modal__docs-item">
                    <div
                      class="ofertas-modal__docs-meta"
                      [class.ofertas-modal__docs-meta--loaded]="docCargado(doc.id)"
                    >
                      <p class="ofertas-modal__docs-name">
                        <span [class.ofertas-modal__docs-name--required]="doc.obligatorio">
                          {{ i + 1 }}. {{ doc.nombre }}
                        </span>
                        @if (!doc.obligatorio) {
                          <span class="ofertas-modal__docs-opt">{{ copy.docsSegmentoOpcional }}</span>
                        }
                        @for (guia of doc.guias; track $index) {
                          <button
                            type="button"
                            class="ofertas-modal__docs-guia"
                            [class.ofertas-modal__docs-guia--pdf]="tipoIconoGuia(guia.extension) === 'pdf'"
                            [class.ofertas-modal__docs-guia--excel]="tipoIconoGuia(guia.extension) === 'excel'"
                            [class.ofertas-modal__docs-guia--word]="tipoIconoGuia(guia.extension) === 'word'"
                            [attr.aria-label]="copy.docsSegmentoDescargarGuia"
                            [ngbTooltip]="copy.docsSegmentoDescargarGuia"
                            [container]="'body'"
                            tooltipClass="stylesToll"
                            placement="top"
                            triggers="hover focus"
                            [openDelay]="200"
                            (click)="onDescargarGuia(guia)"
                          >
                            <span class="material-icons" aria-hidden="true">{{
                              iconoGuia(guia.extension)
                            }}</span>
                          </button>
                          @if (guia.guia) {
                            <span
                              class="ofertas-modal__docs-guia-hint"
                              [ngbTooltip]="guia.guia"
                              [container]="'body'"
                              tooltipClass="stylesToll"
                              placement="top"
                              triggers="hover focus"
                              [openDelay]="200"
                            >
                              <span class="material-icons" aria-hidden="true">help_outline</span>
                            </span>
                          }
                        }
                      </p>
                      @if (docCargado(doc.id)) {
                        <div class="ofertas-modal__docs-file" role="status">
                          <img
                            class="ofertas-modal__docs-file-icon"
                            [src]="assetArchivo"
                            alt=""
                            width="24"
                            height="24"
                          />
                          <div class="ofertas-modal__docs-file-meta">
                            <span class="ofertas-modal__docs-file-name">{{
                              nombreDocCargado(doc.id)
                            }}</span>
                            <span class="ofertas-modal__docs-file-status">{{
                              copy.docsSegmentoCargado
                            }}</span>
                          </div>
                          <button
                            type="button"
                            class="ofertas-modal__docs-icon-btn"
                            [attr.aria-label]="copy.docsSegmentoVer"
                            [ngbTooltip]="copy.docsSegmentoVer"
                            [container]="'body'"
                            tooltipClass="stylesToll"
                            placement="top"
                            triggers="hover focus"
                            [openDelay]="200"
                            (click)="onDocVer(doc.id)"
                          >
                            <span class="material-icons-outlined" aria-hidden="true">visibility</span>
                          </button>
                          <button
                            type="button"
                            class="ofertas-modal__docs-file-remove"
                            [attr.aria-label]="copy.docsSegmentoQuitar"
                            [ngbTooltip]="copy.docsSegmentoQuitar"
                            [container]="'body'"
                            tooltipClass="stylesToll"
                            placement="top"
                            triggers="hover focus"
                            [openDelay]="200"
                            (click)="onDocQuitar(doc.id)"
                          >
                            <span class="material-icons" aria-hidden="true">close</span>
                          </button>
                        </div>
                      } @else {
                        <div class="ofertas-modal__docs-actions">
                          <input
                            #docInput
                            class="ofertas-modal__docs-input"
                            type="file"
                            [accept]="doc.accept || '.pdf,.jpg,.jpeg,.png'"
                            [attr.aria-label]="doc.nombre"
                            (change)="onDocSelected(doc, $event)"
                          />
                          <button
                            type="button"
                            class="ofertas-modal__docs-upload"
                            (click)="docInput.click()"
                          >
                            <span>{{ copy.docsSegmentoCargar }}</span>
                            <span class="material-icons ofertas-modal__docs-upload-icon" aria-hidden="true"
                              >upload</span
                            >
                          </button>
                        </div>
                      }
                    </div>
                  </li>
                }
              </ul>
              }
            </div>
          }
        }

        @if (open === 'rechazar') {
          <p class="ofertas-modal__text">{{ copy.modalRechazarHint }}</p>
          <label class="ofertas-modal__field">
            <select
              class="ofertas-modal__select"
              [class.ofertas-modal__select--placeholder]="!idMotivo"
              [value]="idMotivo"
              (change)="onMotivoChange(+$any($event.target).value)"
            >
              <option [value]="0">{{ copy.motivoPlaceholder }}</option>
              @for (m of motivosLista; track m.id) {
                <option [value]="m.id">{{ m.nombre }}</option>
              }
            </select>
          </label>
          @if (idMotivo === motivoCondiciones) {
            <p class="ofertas-modal__hint">{{ copy.modalRechazarCondiciones }}</p>
            @for (c of condicionesCatalogo; track c.id) {
              <label class="ofertas-modal__check">
                <input
                  type="checkbox"
                  [checked]="condiciones.has(c.id)"
                  (change)="toggleCondicion(c.id)"
                />
                <span>{{ c.nombre }}</span>
              </label>
            }
          }
          @if (idMotivo === motivoOtro) {
            <label class="ofertas-modal__field ofertas-modal__field--required">
              <span class="ofertas-modal__field-label">{{ copy.modalRechazarOtro }}</span>
              <textarea
                class="ofertas-modal__area"
                rows="3"
                [value]="detalle"
                (input)="detalle = $any($event.target).value"
              ></textarea>
            </label>
          }
          <div class="ofertas-modal__actions">
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--soft"
              id="btn-ofertas-rechazar-cancelar"
              (click)="trackModalCta(copy.cancelar, 'btn-ofertas-rechazar-cancelar'); onClose()"
            >
              {{ copy.cancelar }}
            </button>
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--primary"
              id="btn-ofertas-rechazar-confirmar"
              [disabled]="!puedeRechazar || enviando"
              (click)="onRechazar()"
            >
              {{ copy.rechazarOfertas }}
            </button>
          </div>
        }

        @if (open === 'comparar') {
          <div class="ofertas-modal__compare">
            <ul class="ofertas-modal__compare-keys">
              <li>{{ copy.compararMonto }}</li>
              <li>{{ copy.garantias }}</li>
              <li>{{ copy.desembolso }}</li>
              <li>{{ copy.tasa }}</li>
              <li>{{ copy.cuotaAprox }}</li>
              <li>{{ copy.plazo }}</li>
              <li>{{ copy.pago }}</li>
              <li class="ofertas-modal__compare-keys-linea">{{ copy.lineaBancoldex }}</li>
            </ul>
            <div class="ofertas-modal__compare-cols">
              @for (item of seleccionadas; track item.idPropuesta) {
                <article class="ofertas-modal__compare-col">
                  <p class="ofertas-modal__compare-name">
                    <span>{{ item.nombreIntermediario }}</span>
                  </p>
                  <div class="ofertas-modal__compare-vals">
                    <span class="ofertas-modal__compare-val ofertas-modal__compare-val--teal">{{
                      dinero(item.monto)
                    }}</span>
                    <span class="ofertas-modal__compare-val ofertas-modal__compare-val--red">{{
                      dinero(-totalGarantias(item))
                    }}</span>
                    <span class="ofertas-modal__compare-val">{{
                      dinero(item.desembolsoAproximado)
                    }}</span>
                    <span class="ofertas-modal__compare-val">{{ tasaCompare(item.tasa) }}</span>
                    <span class="ofertas-modal__compare-val">{{ dinero(item.cuota) }}</span>
                    <span class="ofertas-modal__compare-val">{{
                      copy.plazoMeses(item.plazo)
                    }}</span>
                    <span class="ofertas-modal__compare-val">{{ item.nombrePeriodicidad }}</span>
                    <span
                      class="material-icons ofertas-modal__compare-icon"
                      aria-hidden="true"
                    >{{ esBancoldex(item) ? 'check' : 'close' }}</span>
                  </div>
                </article>
              }
            </div>
          </div>
        }
      </div>

      @if (open === 'tomar1' && oferta) {
        <div class="ofertas-modal__footer">
          <div class="ofertas-modal__actions">
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--soft"
              id="btn-ofertas-tomar-cancelar"
              (click)="trackModalCta(copy.cancelar, 'btn-ofertas-tomar-cancelar'); onClose()"
            >
              {{ copy.cancelar }}
            </button>
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--primary"
              id="btn-ofertas-si-tomar"
              [disabled]="!acepta078"
              (click)="onTomarSiguiente()"
            >
              {{ copy.siTomarOferta }}
            </button>
          </div>
        </div>
      }

      @if (open === 'tomar2' && oferta) {
        <div class="ofertas-modal__footer">
          <div class="ofertas-modal__actions">
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--soft"
              id="btn-ofertas-confirmar-cancelar"
              (click)="trackModalCta(copy.cancelar, 'btn-ofertas-confirmar-cancelar'); onClose()"
            >
              {{ copy.cancelar }}
            </button>
            <button
              type="button"
              class="ofertas-modal__btn ofertas-modal__btn--primary"
              id="btn-ofertas-confirmar-tomar"
              [disabled]="!puedeConfirmarTomar || enviando"
              (click)="onTomarConfirmar()"
            >
              {{ copy.siTomarOferta }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
